<template>
  <div class="invoice_mini">
    <app-info :order="bill" />

    <table class="table">
      <thead>
        <tr>
          <th class="text-left">
            Item Name
          </th>
          <th class="text-left">
            IMIE
          </th>
          <th class="text-left">
            Serial Number
          </th>
          <th class="text-left">
            Qty
          </th>
          <th class="text-left">
            Price
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in bill.items"
          :key="item.name"
        >
          <td>
            {{ item.name | capitalize }}
          </td>
          <td>
            {{ item.imei }}
          </td>
          <td>
            {{ item.sNumber }}
          </td>
          <td>{{ item.qty }}</td>
          <td>{{ item.price | currency }}</td>
        </tr>
      </tbody>
    </table>

    <hr>
    <p v-if="bill.description">
      <strong> Description :</strong> {{ bill.description | capitalize }}
    </p>
    <h3>Charges : {{ bill.charges | currency }}</h3>
    <terms-conditions />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppInfo from "../common/ComInfo.vue";
import Terms from "../common/Terms.vue";

export default {
  components: {
    "app-info": AppInfo,
    "terms-conditions": Terms,
  },
  data() {
    return {
      bill: {},
    };
  },
  computed: {
    ...mapGetters({
      info: "misc/currentSale",
      configs: "configs/overall",
    }),
  },
  mounted() {
    window.axios.get("/bill/" + this.$route.params.id).then((response) => {
      this.$data.bill = response.data.bill;
      Event.$emit("printSize");
      Event.$emit("loadTerms", "billTerms");
    });
  },
};
</script>
